<template>
  <div>
    <component
      :is="`el-${inputType}`"
      class="license-action__checkbox"
      :value="componentValue"
      :label="inputValue"
      @input="updateValue"
      v-bind="$attrs"
    >
      <div style="display: inline; line-height: 1.25;" v-html="itemHTML"></div>
    </component>
  </div>
</template>

<script>
export default {
  inheritAttrs: false,
  name: 'LicenseAction',
  props: {
    licenseWrapper: {
      type: Object,
      required: true,
    },
    licenseItem: {
      type: Object,
      required: true,
    },
    value: {},
  },
  computed: {
    itemType() {
      return this.licenseItem.itemType;
    },
    itemHTML() {
      return this.licenseItem.itemHTML;
    },
    itemFormName() {
      return this.licenseWrapper.itemFormName;
    },
    inputType() {
      return this.licenseItem.itemAction.inputType || 'checkbox';
    },
    inputValue() {
      return (this.licenseItem.itemAction.inputValue != null)
        ? this.licenseItem.itemAction.inputValue
        : true
      ;
    },
    inputValueDeselect() {
      return (this.licenseItem.itemAction.inputValueDeselect != null)
        ? this.licenseItem.itemAction.inputValueDeselect
        : false
      ;
    },
    componentValue() {
      switch (this.inputType) {
        case 'radio': {
          return this.value;
        }
        case 'checkbox':
        default: {
          return this.value === this.inputValue;
        }
      }
    },
  },
  methods: {
    updateValue(newValue) {
      const updatedValue = newValue ? this.inputValue : this.inputValueDeselect;
      this.$emit('input', [this.itemFormName, updatedValue]);
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Licenses/CommonLicenseComponents/LicenseAction.vue